import AutoSendingIndexPage from "./pages/AutoSendingIndexPage";
import AutoSendingFormPage from "./pages/AutoSendingFormPage";
import FetchMessageTemplatePage from "./pages/FetchMessageTemplatePage";
import ManualSendPage from "./pages/ManualSendPage";
import OutboundMesssageOverviewPage from "./pages/OutboundMesssageOverviewPage";
import AutoSendingReportPage from "./pages/AutoSendingReportPage";

const router = [
  {
    path: "outbound-message/overview",
    element: <OutboundMesssageOverviewPage />,
    loader: () => ({ title: "Overview - ZNS Activities" }),
  },
  {
    path: "outbound-message/fetch-message-template",
    element: <FetchMessageTemplatePage />,
    loader: () => ({ title: "List of ZNS Template" }),
  },
  {
    path: "outbound-message/auto-sending",
    element: <AutoSendingIndexPage />,
    loader: () => ({ title: "Automatic Send" }),
  },
  {
    path: "outbound-message/auto-sending/customer",
    element: <AutoSendingFormPage mode="customer" />,
    loader: () => ({ title: "Auto Sending - Customer" }),
  },
  {
    path: "outbound-message/auto-sending/outlet-owner",
    element: <AutoSendingFormPage mode="outlet-owner" />,
    loader: () => ({ title: "Auto Sending - Outlet Owner" }),
  },
  {
    path: "outbound-message/manual-send",
    element: <ManualSendPage />,
    loader: () => ({ title: "Manual Send" }),
  },
  {
    path: "outbound-message/auto-report",
    element: <AutoSendingReportPage />,
    loader: () => ({ title: "Auto Sending Report" }),
  },
];

export default router;
